<template>
  <div id="exclusive-info" class="listStyle">
    <div class="classify-title">优惠行业-所有行业</div>
    <van-tabs v-model="activeTab" @click="onClick">
      <van-tab title="通用规定">
        <van-checkbox-group>
        <van-cell-group>
          <van-cell v-for="(list, i) in currencyList" :key="i">
            <template #title>
              <div
              v-html="list.fname"
              class="doctitle"
              @click="wordDetail(list)">
            </div>
            </template>
            <template #label>
              <div class="msgContent">
                <div class="time">
                  {{ list.fcode }} {{ list.pdate }}
                </div>
                <div class="tag">
                  <span class="tag">{{ list.potence }}</span>
                </div>
              </div>
            </template>
          </van-cell>
        </van-cell-group>
        </van-checkbox-group>
      </van-tab>
      <van-tab title="专属规定">
        <van-checkbox-group>
        <van-cell-group>
          <van-cell v-for="(item, i) in exclusiveList" :key="i">
            <template #title>
              <div
                v-html="item.fname"
                class="doctitle"
                @click="wordDetail(item)">
              </div>
            </template>
            <template #label>
              <div class="msgContent">
                <div class="time">
                  {{ item.fcode }} {{ item.pdate }}
                </div>
                <div class="tag">
                  <span class="tag">{{ item.potence }}</span>
                </div>
              </div>
            </template>
          </van-cell>
        </van-cell-group>
        </van-checkbox-group>
      </van-tab>
    </van-tabs>
    <!-- 列表组件 -->
    <list-content
      ref="listContent"
    ></list-content>

     <div v-if="currencyList.length > 0" class="pageBoxStyle">
        <Pagination
          :currentPage="currentPage"
          :total="total"
          :totalLists="totalLists"
          @prevPage="prevPage"
          @nextPage="nextPage"
          @jumpToPageSize="jumpToPageSize"
        ></Pagination>
      </div>
    <!-- 法规层级 -->
      <regulations-hierarchy
      ref="regulations"
      @getSearchLists="getSearchLists"></regulations-hierarchy>
    <!-- 底部导航 -->
    <tabbar
      ref="tabbar"
      @alertCengji="alertCengji"
    ></tabbar>
    <!-- 弹框详情 -->
    <!-- <van-popup
      v-model="showDetailPopup"
      position="right"
      :style="{ height: '100%', width: '100%' }"
    >
      <div class="fileElements">
        <div class="docContent" id="moreMerchant">
          <van-collapse v-model="activeNames">
            <van-collapse-item title="文件要素" name="1">
              <div class="elements topLine">
                <div class="title">文件要素</div>
                <div class="content">内容</div>
              </div>
              <div
                class="elements"
                v-for="(item, index) in headers"
                :key="index"
              >
                <div class="title" v-html="item.t"></div>
                <div class="content" v-html="item.v" @click="open"></div>
              </div>
            </van-collapse-item>
          </van-collapse>
          <div
            class="detail defaultFont"
            v-html="value"
            style="background: #fff; padding: 10px"
            @click="open"
          ></div>
        </div>
      </div>
      <div class="backStyle">
        <van-button
          class="oprate-btn"
          :disabled="lastFlag"
          type="info"
          @click="backToLastFire"
          >返回
        </van-button>
        <van-button class="oprate-btn" type="info">关闭</van-button>
        <van-button class="oprate-btn" type="info">分享</van-button>
      </div>
    </van-popup> -->
  </div>
</template>

<script>
import Pagination from "@/components/common/pagination"; // 分页
import ListContent from "@/components/common/listContent";
import Tabbar from "@/components/common/tabbar";
import RegulationsHierarchy from "@/components/common/regulationsHierarchy";
export default {
  data() {
    return {
      activeTab: 0,
      isFilter: false,
      currentPage: 1,
      currencyList: [],
      total: 0,
      totalLists: 0, // 总的条数
      exclusiveList: [],
      showDetailPopup: false, // 弹出框
      headers: [], // 文件要素
      activeNames: ["1"],
      value: "", // 文件正文内容
      lastFlag: true,
      showDetail: false,
      changedtagpc: [],
      cenjiFlag: false,
      proAndCityData: {},
      t1: [],
      t2: [],
      t3: [],
    }
  },
  components: {
    Pagination,
    ListContent,
    Tabbar,
    RegulationsHierarchy
  },
  created() {
    this.getInfo()
  },
  methods: {
    // 点击弹出法规层级框
    alertCengji() {
      this.$refs.regulations.alertCengji();
      if (this.cenjiFlag === true) {
        this.$refs.regulations.processData(this.proAndCityData)
      }
    },
    // 选择省份城市后触发的事件
    getSearchLists(tagpc) {
      console.log("ABC==》", tagpc)
      this.isFilter = true;
      this.changedtagpc = tagpc;
      console.log("this.tagpc", this.tagpc);
      this.currentPage = 1;
      this.getInfo()
    },
    // 点击内容详情
    wordDetail(doc) {
      console.log('123', doc)
      //this.getDetail(doc);
      this.$refs.listContent.getDetail(doc)
    },
    // 切换tab
    onClick(name, title) {
      this.activeTab = name
      this.getInfo()
    },
    // 点击详情里面的链接 跳转相应的页面
    open(value) {
      console.log("value123", value)
    },
    getInfo() {
      let treeId
      if(this.activeTab == 0) {
        treeId = '000004000001'
      } else {
        treeId = '000004000002'
      }
      let args = {
        searchtimes: 1, // 查询次数，第一次查询一定传1，二次查询传2
        frist: {
          text: "",
          potence: "1",
          icode: "",
          tcode: "",
          kcode: "",
          country: "",
          ps: {
            p: "510000",
            c: "510100"
          },
          dirid: "", // 上传目录ID，云端查询需要这个参数
          id: treeId,
          stime: "",
          etime: "",
        },
        second: [],
        fliter: {
          isfilter: this.isFilter,
          tagpc: this.isFilter ? this.changedtagpc : [],
          tagid: "",
        },
        pager: [
          {
            pagesize: 10, // 当前页
            pageindex: this.currentPage, // 每页显示的条数
          }
        ]
      }
      let nodes = this.$baseConfig.code;
      this.$http
        .reqGetLocalLastFiles(args, nodes)
        .then((response) => {
          if (response.rtncode === 1) {
            if (response.rltcode === 1) {
              
              if(this.activeTab == 0) {
                console.log("通用数据", response)
                this.currencyList = response.tbls[0].items
              } else {
                console.log("专属数据", response)
                this.exclusiveList = response.tbls[0].items
              }
              this.total = Math.ceil(response.tbls[0].total / 10);
              this.totalLists = response.tbls[0].total; // 总的条数
              this.t1 = response.tbls[0].divisiontag.length !== 0 &&
                        response.tbls[0].divisiontag.t1.length > 0 ?
                        response.tbls[0].divisiontag.t1
                        : []
              this.t2 = response.tbls[0].divisiontag.length !== 0 &&
                        response.tbls[0].divisiontag.t2.length > 0 ?
                        response.tbls[0].divisiontag.t2
                        : []
              this.t3 = response.tbls[0].divisiontag.length !== 0 &&
                        response.tbls[0].divisiontag.t3.length > 0 ?
                        response.tbls[0].divisiontag.t3
                        : []
              this.t2 = this.t2.sort((a,b) => a.id - b.id)
              this.t3 = this.t3.sort((a,b) => a.id - b.id)

              this.proAndCityData = {
                t1: this.t1.length > 0 ? this.t1 : [],
                t2: this.t2.length > 0 ? this.t2 : [],
                t3: this.t3.length > 0 ? this.t3 : []
              }
              this.tagpc = this.filterData(this.proAndCityData)
              this.cenjiFlag = true
            } else {
              warningNotify(response.rltdesc, this);
              this.showLoding = false;
            }
          } else {
            warningNotify(response.rtndesc, this);
            this.showLoding = false;
          }
        })
        .catch(() => {
          this.showLoding = false;
        });
    },
    
    // 筛选城市数据-城市id
    filterData(data) {
      let searchParameter = []
      let national = []
      let tagpc1 = []
      let tagpc2 = []
      if (data.t1.length > 0) {
        national = [{ p: "000000", c:"000000"}]
      }
      if (data.t2.length > 0) {
        data.t2.forEach((item) => {
          let stringlength = item.id.length
          let pstring = item.id.substring(0, 6)
          let nstring = item.id.substring(stringlength - 6, stringlength) // 截取后六位
          tagpc1.push({ p: pstring, c: nstring })
        })
      }
      if (data.t3.length > 0) {
        data.t3.forEach((item) => {
          if (item.children && item.children.length > 0) {
            item.children.forEach((item1) => {
              let stringlength = item1.id.length
              let pstring = item1.id.substring(0, 6)
              let nstring = item1.id.substring(stringlength - 6, stringlength); // 截取后六位
              tagpc2.push({ p: pstring, c: nstring })
            })
          }
        })
      }
      searchParameter = [...national, ...tagpc1, ...tagpc2]
      console.log("searchParameter", searchParameter)
      return searchParameter.length > 0? searchParameter : this.tagpc
    },

    prevPage() {
      // 上一页
      if (this.currentPage == 1) return;
      this.currentPage--;
      this.getInfo();
    },
    nextPage() {
      // 下一页
      if (this.currentPage == this.total) return;
      this.currentPage++;
      this.getInfo();
    },
    jumpToPageSize(num) {
      // 跳转到多少页
      this.currentPage = num;
      this.getInfo();
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/variable.less";
@--line-color: #dcdee2;

#exclusive-info {
  height: calc(100% - 20px);
  overflow-y: auto;
  .classify-title {
    text-align: center;
  }
  .fileElements {
    height: 100%;
    background: #fff;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none; // 重点
    }
    .topLine {
      border-top: 1px solid @--line-color;
    }
    .elements {
      display: flex;
      min-height: 40px;
      border-bottom: 1px solid @--line-color;
      color: #515a6e;
      font-size: 12px;
      border-right: 1px solid @--line-color;
      &:nth-child(odd) {
        background-color: #f8f8f9;
      }
      .title {
        flex: 0 0 27%;
        text-align: center;
        border-left: 1px solid @--line-color;
        border-right: 1px solid @--line-color;
        line-height: 40px;
      }
      .content {
        flex: 1;
        text-align: center;
        // border-right: 1px solid @--line-color;
        margin: auto 0;
      }
    }
    .docContent {
      margin-bottom: 60px;
    }
  }
  .backStyle {
    background-color: #fff;
    display: flex;
    align-items: center;
    .oprate-btn {
      height: 100%;
      width: 3.2rem;
      border-radius: 30px;
      height: 40px;
    }
  }
  /deep/.van-cell__title {
    width: 100%;
  }
  .doctitle {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #656565;
    font-weight: 600;
    // border: 1px solid red;
  }
  .msgContent {
    width: 100%;
    font-size: 12px;
    color: #a6a6a6;
    display: flex;
    justify-content: space-between;
    .time {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .tag {
      min-width: 50px;
      margin-left: 4px;
      .tag {
        width: 100%;
        color: @--base-word-color;
      }
    }
  }
  .pageBoxStyle {
    width: 100%;
    position: fixed;
    bottom: 50px;
    left: 0;
    font-size: 0.37333rem;
    flex: 0 0 50px;
    background-color: #fff;
  }
}

</style>

<style lang="less">
  p {
  margin: 0pt 2pt;
  font-weight: normal;
}

//文件名
hh1 {
  display: block;
  text-align: center;
  line-height: 170%;
  font-size: 14pt;
  font-weight: normal;
  font-weight: 700;
}

hh1 {
  display: block;
  text-align: center;
  line-height: 170%;
}
//文号
hh2 {
  text-align: center;
  line-height: 300%;
  font-size: 8pt;
  font-weight: normal;
  display: block;
  margin-top: 10pt;
}

//废止依据
hh3 {
  text-align: justify;
  line-height: 200%;
  font-size: 12pt;
  font-weight: normal;
  display: block;
}

hh4 {
  text-align: justify;
  line-height: 200%;
  font-size: 12pt;
  font-weight: normal;
  display: block;
}

hh41 {
  text-align: justify;
  line-height: 200%;
  font-size: 12pt;
  font-weight: normal;
  display: block;
}

hh42 {
  text-align: justify;
  line-height: 200%;
  font-size: 12pt;
  font-weight: normal;
  display: block;
}

//发文单位
hh5 {
  text-align: right;
  line-height: 200%;
  font-size: 11pt;
  font-weight: normal;
  display: block;
}

//发文时间
hh6 {
  text-align: right;
  line-height: 200%;
  font-size: 11pt;
  font-weight: normal;
  display: block;
}

//附件
hh7 {
  text-align: justify;
  line-height: 200%;
  font-size: 12pt;
  font-weight: normal;
  display: block;
}

//相关链接
hh81 {
  text-align: justify;
  line-height: 200%;
  font-size: 12pt;
  font-weight: normal;
  display: block;
}

//版本汇总
hh82 {
  text-align: justify;
  line-height: 200%;
  font-size: 12pt;
  font-weight: normal;
  display: block;
}

sc {
  text-align: justify;
  line-height: 180%;
  font-size: 11pt;
  font-weight: normal;
  display: block;
  margin-top: 6pt;
}

basis {
  font-size: 12pt;
  font-weight: normal;
  line-height: 200%;
  color: #c00000;
}

potencedesc {
  text-align: justify;
  line-height: 200%;
  font-size: 12pt;
  font-weight: normal;
  display: block;
  color: #c00000;
}

tt {
  text-align: justify;
  line-height: 200%;
  font-size: 12pt;
  font-weight: normal;
}

sr {
  color: #c00000;
}

.ls {
  //text-decoration: underline;
  color: blue;
  cursor: Pointer;
}

.ls_w:after {
  font-family: "iconfont" !important;
  font-size: 12pt;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\e62e";
}

.ls_e {
  color: blue;
  cursor: Pointer;
}

.ls_z {
  color: blue;
  cursor: Pointer;
}

.ls_o {
  color: blue;
  cursor: Pointer;
}

.defaultFont {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  position: relative; 
}

#hh9 {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: 50px 50px 50px;
  grid-auto-flow: column;
}

hh9 {
  font-size: 16px;
  text-align: left;
  //border: 1px solid #e5e4e9;
}

hit {
  background-color: yellow;
}

</style>

